import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import * as UserService from "../../services/UserService";
import backImg from "../../assets/img/icon_back.svg";
import analyticsLogEvent from "../../services/FirebaseService";
import {FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import Spinner from "../../components/Spinner";
import {useNavigate} from "react-router";
import warningImg from "../../assets/img/warning.svg";
import {PATH} from "../../routes/routes";
import Calendar from "react-calendar";

function ProfileUpdate() {
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    let userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const today = new Date();
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        email: userInfo?.email,
        firstName: userInfo?.firstName,
        lastName: userInfo?.lastName,
        birthDay: userInfo?.birthDay,
        phoneNumber: userInfo?.phone ? userInfo?.phone : null,
        phoneNumberConfirmationCode: ['', '', '', ''],
        confirmationPinCodeVisible: false,
        gender: userInfo?.gender,
        isSubmitBtnEnabled: true,
        updatedAccountPopupStyle: hidden,
    });


    useEffect(() => {

        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE
        });
    }, []);


    const goBack = () => {
        navigateTo(-1);
    }




    const handleOnChange = (e, input) => {

        if (input === "firstName") {
            setState({
                ...state,
                firstName: e.target.value
            })
        } else if (input === "lastName") {
            setState({
                ...state,
                lastName: e.target.value
            })
        } else if (input === "email") {
            setState({
                ...state,
                email: e.target.value
            })
        } else if (input === "birthDay") {
            setState({
                ...state,
                birthDay: e,
                calendarIsVisible:false
            })
        } else if (input === "gender") {
            setState({
                ...state,
                gender: e.target.value
            })
        } else if (input === "phoneNumber") {
            setState({
                ...state,
                phoneNumber: e.target.value
            })
        }
    }


    const toUpdatePhone = () => {
        navigateTo(PATH.PROFILE_UPDATE_PHONE);
    }


    const handleSubmit = async () => {
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })

        if (!state.isSubmitBtnEnabled || state.loading) {
            return;
        }

        const error = validateInputs();
        if (error) {
            setState({
                ...state,
                errorMsg: error
            })
            return;
        }

        const body = {
            "firstName": state.firstName,
            "lastName": state.lastName,
            "email": state.email,
            "birthDay": state.birthDay ? new Date(state.birthDay) : null,
            "gender": state.gender ? state.gender : null,
            "phone": state.phoneNumber ? state.phoneNumber : null
        }

        const response = await UserService.updateUserInformation(body);
        if (response.ok) {
            userInfo = {
                ...userInfo,
                "firstName": state.firstName,
                "lastName": state.lastName,
                "birthDay": state.birthDay ? new Date(state.birthDay) : null,
                "gender": state.gender ? state.gender : null,
                "phoneNumber": state.phoneNumber ? state.phoneNumber : null
            }
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_INFO, JSON.stringify(userInfo));
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_EMAIL, userInfo.email);
            setState({
                ...state,
                updatedAccountPopupStyle: visible,
                loading: false,
                isSubmitBtnEnabled: false
            })

            setTimeout(function () {
                setState({
                    ...state,
                    updatedAccountPopupStyle: hidden,
                    isSubmitBtnEnabled: true
                })
            }, 2000);
        } else {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                errorMsg: <FormattedMessage id="Error.genericError"/>,
                loading: false,
            })
        }
    }

    const validateInputs = () => {
        if (state.firstName === null || state.firstName === "" || state.lastName === null || state.lastName === "") {
            return <FormattedMessage id="FirstNameLastNameCannotBeBlank"/>;
        } else if (state.phoneNumber === null || state.phoneNumber === "") {
            return <FormattedMessage id="PleaseEnterAvalidPhone"/>;
        } else if (!/^\+?[0-9-]{3,}$/.test(state.phoneNumber)) {
            return <FormattedMessage id="Error.incorrectPhoneFormat"/>;
        } else return null;
    }

    const openCalendar = () => {
        setState({
            ...state,
            calendarIsVisible: true
        })
        document.body.classList.add("blocked");
    }

    const closeCalendar = () => {
        setState({
            ...state,
            calendarIsVisible: false
        })
        document.body.classList.remove("blocked");
    }


    return (
        <div className="page-content without-actionsbar">
            <div className={state.updatedAccountPopupStyle + " modal-overlay always-invisible"}></div>
            <div className="modal confirmation-modal" data-qa="update-profile-success-modal">
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="YourPersonalDataHasBeenUpdated"/></p>
                </div>
            </div>


            <div className="login-container">
                <a className="btn-back" onClick={goBack} data-qa="update-profile-back-btn"><img alt="back button"
                                                                                                src={backImg}/></a>
                {/*<div className="login-container-top-img">*/}
                {/*    <img src={loginBackground} alt="login background"/>*/}
                {/*</div>*/}

                <div className="login-container-content text-left">
                    <div className="login-container-content-top-text">
                        <FormattedMessage id="PersonalData"/>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <label>{<FormattedMessage id="FirstName"/>} *</label>
                            <FormattedMessage id="FirstName" defaultMessage="FirstName">
                                {placeholder =>
                                    <input
                                        className="input"
                                        type="text"
                                        value={state.firstName}
                                        onChange={e => handleOnChange(e, "firstName")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="firstName"
                                        data-qa="update-profile-firstname-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="LastName"/>} *</label>
                            <FormattedMessage id="LastName" defaultMessage="LastName">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        type="text"
                                        value={state.lastName}
                                        onChange={e => handleOnChange(e, "lastName")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="lastName"
                                        data-qa="update-profile-lastname-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="Email"/>}</label>
                            <FormattedMessage id="Email" defaultMessage="Email">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        readOnly={true}
                                        disabled={true}
                                        value={state.email}
                                        onChange={e => handleOnChange(e, "email")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="email"
                                        data-qa="update-profile-email-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>


                        <div className="row">
                            <label>{<FormattedMessage id="BirthYear"/>}</label>
                            {state.calendarIsVisible &&
                            <>
                                <div onClick={closeCalendar}
                                     className={!state.calendarIsVisible ? "blurry-background hidden" : "blurry-background"}>
                                </div>



                                <Calendar
                                    view="decade"
                                    onClickYear={e => handleOnChange(e, "birthDay")}
                                    maxDate={today}
                                    showNavigation={true}
                                    locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}
                                    className={"custom-calendar"}
                                />
                            </>
                            }


                            <FormattedMessage id="BirthYear" defaultMessage="BirthYear">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        readOnly={true}
                                        onFocus={() => openCalendar()}
                                        onClick={() => openCalendar()}
                                        value={state.birthDay ? new Date(state.birthDay).getFullYear() : ""}
                                        placeholder={""}
                                        autoComplete="off"
                                        id="readonly"

                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="PhoneNo"/>} *</label>
                            <FormattedMessage id="PhoneNo" defaultMessage="PhoneNo">
                                {placeholder =>
                                    <input
                                        className="input"
                                        onFocus={() => toUpdatePhone()}
                                        onClick={(e) => toUpdatePhone()}
                                        maxLength={80}
                                        value={state.phoneNumber}
                                        autoComplete="off"
                                        id="phoneNumber"
                                        data-qa="update-profile-phoneNumber-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>


                    </div>
                    {/*<div className="row">*/}
                    {/*    <label className="radio" htmlFor="option">*/}
                    {/*        <input*/}
                    {/*            type="radio"*/}
                    {/*            value="MALE"*/}
                    {/*            name="MALE"*/}
                    {/*            checked={state.gender === "MALE"}*/}
                    {/*            onChange={e => handleOnChange(e, "gender")}*/}
                    {/*            data-qa="update-profile-male-radio-input"*/}
                    {/*        />*/}
                    {/*        <span className="checkround"></span>*/}
                    {/*        <FormattedMessage id="Man"/>*/}
                    {/*    </label>*/}

                    {/*    <label className="radio" htmlFor="option">*/}
                    {/*        <input*/}
                    {/*            type="radio"*/}
                    {/*            value="FEMALE"*/}
                    {/*            name="FEMALE"*/}
                    {/*            checked={state.gender === "FEMALE"}*/}
                    {/*            onChange={e => handleOnChange(e, "gender")}*/}
                    {/*            data-qa="update-profile-female-radio-input"*/}
                    {/*        />*/}
                    {/*        <span className="checkround"></span>*/}
                    {/*        <FormattedMessage id="Woman"/>*/}
                    {/*    </label>*/}
                    {/*</div>*/}

                    {/*<div className="optional-msg">*/}
                    {/*    <FormattedMessage id="BirthdateAndGenderAreOptional"/>*/}
                    {/*</div>*/}





                    {!userInfo?.phone &&

                    <div className="row" onClick={(e) => toUpdatePhone()}>
                        <div className="banner danger with-icon clickable">
                            <div className="left-img-col img-col">
                                <img src={warningImg}/>
                            </div>
                            <div className="banner-inner-col">
                                <div className="title"><FormattedMessage id="PhoneVerificationRequired"/></div>
                                <div className="banner-content"><FormattedMessage id="FillPhoneNumber"/></div>
                            </div>
                        </div>
                    </div>

                    }
                    <div className="row">
                        <button onClick={() => handleSubmit()}
                                className={state.isSubmitBtnEnabled ?
                                    "btn btn-md btn-default uppercase register-btn"
                                    : "btn btn-md btn-default uppercase register-btn btn-disabled"}
                                data-qa="update-profile-submit-btn">
                            <FormattedMessage id="Update" defaultMessage="Update"/>
                        </button>
                    </div>

                </div>

                {state.loading ?
                    <div className="spinner" data-qa="spinner"><Spinner/></div>
                    : null
                }

                {state.errorMsg != null ?
                    <div className="error-div" data-qa="update-profile-error-div">
                        <p>&#9888;&nbsp;{state.errorMsg}</p>
                    </div>
                    : null
                }
            </div>
        </div>

    );
}

export default ProfileUpdate;
